import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PublicAppSection } from '../../core/store/ui/ui.state';
import { Store } from '@ngrx/store';
import { fromStore } from '../../core/store';
import { selectUiState } from '../../core/store/reducers';
import { Vendor } from '../../core/models/entities/vendor';

@Component({
  selector: 'app-footer',
  template: `
    <div class="mt-20 bg-[#4F4F4F] py-20 text-white">
      <div class="container">
        <div class="grid grid-cols-1 lg:grid-cols-3">
          @if (vendor$ | async) {
            <div class="col-span-1">
              <div class="font-bold uppercase">{{ (vendor$ | async)?.name }}</div>
              <div>{{ (vendor$ | async)?.address }}</div>
              <div
                >{{ (vendor$ | async)?.zip }} {{ (vendor$ | async)?.city }}</div
                >
              </div>
            } @else {
              <div class="col-span-1">
                <a href="https://www.ercos.ch" target="_blank">
                  <img
                    class="w-14"
                    src="/assets/img/ercos-gris.svg"
                    alt="Développé par Ercos SA"
                    title="Développé par Ercos SA"
                    />
                </a>
                <div class="pt-3 font-bold uppercase">Ercos SA</div>
                <div>Route de la Clochatte 69</div>
                <div>1052 Le Mont-sur-Lausanne</div>
              </div>
            }
            <div class="col-span-1 mt-8 flex lg:mt-0 lg:justify-center">
              @if (B2C$ | async) {
                <div>
                  <div
                    >@if ((vendor$ | async)?.general_terms_public_url) {
                    <a
                      [href]="(vendor$ | async)?.general_terms_public_url"
                      target="_blank"
                      >Conditions générales</a
                      >
                      }</div
                      >
                      <div
                        ><a
                  [routerLink]="[
                    '/louer-salle',
                    (vendor$ | async)?.slug,
                    'politique-confidentialite',
                  ]"
                        >Politique de confidentialité</a
                        ></div
                        >
                        <div
                          ><a
                          href="javascript:void(0);"
                          class="biskoui-button-show-banner"
                          >Paramètres de confidentialité</a
                          ></div
                          >
                        </div>
                      }
                      @if ((B2C$ | async) === false) {
                        <div>
                          <div
                            ><a routerLink="/conditions-generales" target="_blank"
                            >Conditions générales</a
                            ></div
                            >
                            <div
                              ><a routerLink="/politique-confidentialite" target="_blank"
                              >Politique de confidentialité</a
                              ></div
                              >
                              <div
                                ><a
                                href="javascript:void(0);"
                                class="biskoui-button-show-banner"
                                >Paramètres de confidentialité</a
                                ></div
                                >
                                <div
                                  ><a routerLink="/permissions">Rôles et droits d'accès</a></div
                                  >
                                </div>
                              }
                            </div>
    
                            @if (vendor$ | async) {
                              <div
                                class="col-span-1 mt-8 flex lg:mt-0 lg:justify-end"
                                >
                                <div class="space-y-2">
                                  @if ((vendor$ | async)?.email) {
                                    <div>
                                      <a
                                        class="no-underline"
                                        href="mailto:{{ (vendor$ | async)?.email }}"
                                        >
                                        <i class="fal fa-paper-plane mr-1"></i>
                                        {{ (vendor$ | async)?.email }}
                                      </a>
                                    </div>
                                  }
                                  @if ((vendor$ | async)?.phone) {
                                    <div>
                                      <a
                                        class="no-underline"
                                        href="tel:{{ (vendor$ | async)?.phone }}"
                                        >
                                        <i class="fal fa-phone mr-1"></i>
                                        {{ (vendor$ | async)?.phone }}
                                      </a>
                                    </div>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="col-span-1 mt-8 flex lg:mt-0 lg:justify-end">
                                <div class="space-y-2">
                                  <div>
                                    <a class="no-underline" href="mailto:contact@ercos.ch">
                                      <i class="fal fa-paper-plane mr-1"></i>
                                      contact&#64;ercos.ch
                                    </a>
                                  </div>
                                  <div>
                                    <a class="no-underline" href="tel:0215253060">
                                      <i class="fal fa-phone mr-1"></i>
                                      021 525 30 60
                                    </a>
                                  </div>
                                  <div>
                                    <a
                                      class="no-underline"
                                      href="https://www.ercos.ch"
                                      target="_blank"
                                      >
                                      <i class="fal fa-globe mr-1"></i>
                                      ercos.ch
                                    </a>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
    
                          @if (B2C$ | async) {
                            <div class="mt-10 text-sm">
                              <div
                                >Les salles louées par l'intermédiaire de ce site sont gérées et
                                facturées par : {{ (vendor$ | async)?.name }}.
                              </div>
                              <div class="mt-1"
                                >Développé par
                                <a href="https://www.ercos.ch" target="_blank">Ercos SA</a>.</div
                                >
                              </div>
                            }
                          </div>
                        </div>
    `,
  standalone: false,
})
export class FooterComponent implements OnInit {
  B2C$: Observable<boolean> = this.store
    .select(fromStore.selectPublicAppSection)
    .pipe(
      map((publicAppSection: PublicAppSection) => {
        return publicAppSection === PublicAppSection.B2C;
      }),
    );
  vendor$: Observable<Vendor | null> = this.store
    .select(selectUiState)
    .pipe(
      map((uiState) =>
        uiState.publicAppSection === PublicAppSection.B2C
          ? uiState.vendor
          : null,
      ),
    );

  constructor(private store: Store) {}

  ngOnInit(): void {}
}
